var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiSuggestedSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 8.66663C9.46337 8.95831 7.62469 10.797 7.33301 14.1666C7.02903 10.7446 5.19995 9.048 1.83301 8.66663C5.25317 8.27215 6.93853 6.58679 7.33301 3.16663C7.71438 6.53357 9.41095 8.36265 12.833 8.66663Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1935 0.839186C13.1824 0.740969 13.0994 0.666727 13.0005 0.666626C12.9017 0.666525 12.8185 0.740597 12.8072 0.838791C12.7335 1.47731 12.5426 1.92629 12.2346 2.23427C11.9267 2.54224 11.4777 2.73315 10.8392 2.8068C10.741 2.81812 10.6669 2.90131 10.667 3.00016C10.6671 3.099 10.7413 3.18204 10.8396 3.19317C11.4675 3.2643 11.926 3.45512 12.2413 3.76471C12.5554 4.07314 12.7503 4.52202 12.8066 5.15605C12.8156 5.25646 12.8997 5.33341 13.0005 5.33329C13.1013 5.33318 13.1854 5.25605 13.194 5.15562C13.248 4.53202 13.4427 4.07369 13.7584 3.75803C14.0741 3.44237 14.5324 3.24766 15.156 3.19368C15.2564 3.18499 15.3335 3.10098 15.3337 3.00018C15.3338 2.89937 15.2568 2.8152 15.1564 2.80628C14.5224 2.74996 14.0735 2.55507 13.7651 2.24096C13.4555 1.92567 13.2647 1.46715 13.1935 0.839186Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSuggestedSparkle);
export default __webpack_public_path__ + "static/media/ai-suggested-sparkle.2adc6c6c.svg";
export { ForwardRef as ReactComponent };